<script>
    import Panel from "./content-panel/Panel.svelte";
    import { onMount, onDestroy } from 'svelte';
    import { t, locale, locales } from "../../scripts/i18n";
    import MoneyBackBlock from "./MoneyBackBlock.svelte";

    export let params = {};
    let divHeight;

    let username = params && params.status ? params.account.username : $t('photographer.london');

    onMount(() => {
        window.scrollTo(0, 0);
    });


</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="icon">
                <img src="/static/media/Vector (14).49e653f6.svg" alt="/" class="scan-block_top-img mr-5px">
            </span>
            <span slot="title">{$t('Choose and pay tariff')}</span>
            <div slot="content">

                <div class="report_content price-page-con">
                    <p class="payment-h">
                        {@html $t('Here you can pay full access to Bot-Removal service to protect account', {username: username})}
                    </p>
                    {#if (window.language !== 'ru-RU')}
                        <div class="payment-h">✓ 14-day money-back guarantee</div>
                    {/if}

                    <div class="prices-wrap">
                        <div class="px-5px mb-20px">
                            <div class="price-wrap one-month">
                                <div class="title-wrap">{$t('For 1 month')}</div>
                                <div class="price-value">{$t('$47.00/month')}</div>

                                <div class="fixed-height-wrap">
                                    <div class="period-description-wrap">
                                        {$t('* when paying for the month')}
                                    </div>
                                    <div class="description-wrap mb-10px">
                                        {$t('Full Access to Bot-Removal service features for 1 month')}
                                    </div>
                                </div>

                                <a href="#" class="mx-auto purple-btn_hover purple-btn h-32px w-115px">{$t('Buy now')}</a>
                            </div>
                        </div>
                        <div class="px-5px mb-20px">
                            <div class="price-wrap six-months">
                                <div class="title-wrap">{$t('For 6 months')}</div>
                                <div class="price-value">{$t('prise for 6 months')}</div>

                                <div class="fixed-height-wrap">
                                    <div class="period-description-wrap">
                                        {$t('* when paying for 6 months')}
                                    </div>
                                    <div class="description-wrap mb-10px">
                                        {$t('Full Access to Bot-Removal service features for 6 months with 40% sale')}
                                    </div>
                                </div>

                                <a href="#" class="mx-auto purple-btn_hover purple-btn h-32px w-115px">{$t('Buy now')}</a>
                            </div>
                        </div>
                        <div class="px-5px mb-20px">
                            <div class="price-wrap guard-only">
                                <div class="title-wrap">{$t('Protection only')}</div>
                                <div class="price-value">{$t('$28.20/month')}</div>

                                <div class="fixed-height-wrap">
                                    <div class="period-description-wrap">
                                        {$t('* when paying for the month')}
                                    </div>
                                    <div class="description-wrap mb-10px">
                                        {$t('Real-time protection from ghosts, spam-comments, spam-tags or spam-direct requests')}
                                    </div>
                                </div>

                                <a href="#" class="mx-auto purple-btn_hover purple-btn h-32px w-115px">{$t('Buy now')}</a>
                            </div>
                        </div>
                        <div class="px-5px mb-20px position-relative">
                            <div class="price-wrap premium">
                                <div class="title-wrap">Premium</div>
                                <div class="price-value">{$t('$97.35/month')}</div>

                                <div class="fixed-height-wrap">
                                    <div class="description-wrap mb-10px">
                                        <ul class="text-left">
                                            <li>{$t('Unlimited number of analyses')}</li>
                                            <li>{$t('Personal Manager')}</li>
                                            <li>{$t('Improved algorithms')}</li>
                                        </ul>

                                        <div class="text-left">
                                            <a href="{window.language === 'ru-RU' ? '/site/premium-info' : '/site/premium-info-en' }" target="_blank" style="color: rgb(242, 197, 2);">{$t('Learn more...')}</a>
                                        </div>
                                    </div>
                                </div>

                                <a href="#" class="mx-auto purple-btn_hover purple-btn h-32px w-115px">{$t('Buy now')}</a>
                            </div>

                            <svg width="47" height="24" viewBox="0 0 47 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 35px; right: -15px;"><rect width="47" height="24" rx="5" fill="#F2C502"></rect><path d="M17.3203 17H15.5908L11.1543 9.93848V17H9.4248V7.04688H11.1543L15.6045 14.1357V7.04688H17.3203V17ZM25.1816 12.5566H21.0938V15.6191H25.8721V17H19.3643V7.04688H25.8242V8.44141H21.0938V11.1895H25.1816V12.5566ZM35.0869 14.5391L36.6182 7.04688H38.334L36.0371 17H34.3828L32.4893 9.7334L30.5547 17H28.8936L26.5967 7.04688H28.3125L29.8574 14.5254L31.7578 7.04688H33.207L35.0869 14.5391Z" fill="#171717"></path></svg>
                        </div>

                    </div>

                    {#if (window.language === 'ru-RU')}
                        <div class="prices-wrap">
                            <div class="px-5px mb-20px position-relative" style="margin-left: auto; margin-right: auto; float: none;">
                                <div class="price-wrap best-seller">
                                    <p class="rate-div-big-p_top">Самый популярный</p>
                                    <p class="rate-div-big-price">436.00 ₽/мес.</p>
                                    <p class="rate-div-big-p">* при оплате на 1 год</p>
                                    <p class="rate-div-big-bottom mb-34px">Доступ к 36 очисткам на 1 год</p>
                                    <p class="rate-div-big-saving">Экономия 60%</p>
                                    <div class="buy-button-ru">
                                        <a type="button" class="btn btn-info btn-md year-buy-btn">Купить</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}

                    <p class="modal-body-bottom-p modal-body-bottom-p_top_padding">
                        {$t('By paying for full access to the service with your bank card, you accept the terms of the')}
                        <br>
                        {#if (window.language === 'ru-RU')}
                            <a target="_blank" href="/terms"> Пользовательского соглашения </a> и <a target="_blank" href="/privacy-policy"> Политики конфиденциальности </a>
                        {:else}
                            <a target="_blank" href="#"> User Agreement. </a>
                        {/if}
                    </p>

                    {#if (window.language === 'en-US')}
                        <MoneyBackBlock />
                    {/if}
                </div>

            </div>
        </Panel>
    </div>
</div>

<style>
    .prices-wrap > div {
        width: 25%;
    }
    .year-buy-btn {
        background: #fff;
        color: #8001bd;
        width: 90%!important;
        font-weight: 400;
        height: 50px;
        border-radius: 15px;
        font-family: 'Roboto';
        padding: 15px;
        font-size: 16px;
    }
    .price-wrap.best-seller {
        background: rgba(148,0,211,.5);
        border: 3px solid #8001bd;
        color: #fff;
    }
    @media (min-device-width: 480px) {
        .price-wrap.best-seller {
            width: 290px;
            margin-left: -50px;
        }
    }
    @media (max-device-width: 480px) {
        .prices-wrap {
            flex-direction: column;
        }
        .prices-wrap > div {
            width: 100%;
        }
    }

    .fixed-height-wrap {
        min-height: 115px;
    }
    .prices-wrap {
        display: flex;
        justify-content: center;
        align-items: normal;
    }

    .price-wrap {
        text-align: center;
        background: #fff;
        border: 1px solid #8a8585;
        box-sizing: border-box;
        box-shadow: 0 4px 10px rgba(0,0,0,.15);
        border-radius: 21px;
        padding: 20px 5px 10px;
        min-height: 270px;
    }
    .price-wrap .title-wrap {
        font-family: Roboto;
        font-style: normal;
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        color: #000;
        font-weight: 400;
        margin-bottom: 10px;
    }
    .price-wrap .price-value {
        font-weight: 600;
        margin-bottom: 20px;
        font-family: Roboto;
        font-style: normal;
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        margin-bottom: 18px;
    }
    .price-wrap.premium {
        color: #fff;
        background-color: #000;
    }
    .price-wrap.premium .title-wrap {
        color: rgb(242, 197, 2);
    }
    .price-wrap .description-wrap, .price-wrap .period-description-wrap {
        line-height: 17px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        text-align: center;
    }
    .price-wrap .description-wrap {
        min-height: 66px;
    }
    .price-wrap.premium .description-wrap {

    }

    .description-wrap ul {
        padding-left: 20px;
        margin-bottom: 0px;
    }
</style>